// extracted by mini-css-extract-plugin
export default {"innerWrapper":"rt-z","tooltipWrapper":"st-z","icon":"tt-z","tooltip":"ut-z","content":"vt-z"};